import report from './src/index'

export default report
